import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TreeNode } from '../../models/tree-models';

@Component({
  selector: 'app-fs-footer',
  templateUrl: './filesystem-footer.component.html',
  styleUrls: ['./filesystem-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileSystemFooterComponent {
  @Input() folderElement: number = 0;
  @Input() activeNode: TreeNode;
  @Input() selectedNode: TreeNode;
  @Input() moveFiletoggle: boolean = false;
  @Output() moveFiletoggleHandler: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() moveHandler: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() createNewFolder: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}
}
